import React from "react";
import Image from "next/image";
import Check from "assets/images/check.png";
import { Star } from "assets/svgs";
import { SignUpImage, LayoutWrapper, FormDiv } from "./signp.styles";

type Props = {
   children?: React.ReactNode
 };

export const SignupLayout: React.FC<Props> = ({ children }) => {
   return (
      <LayoutWrapper>
         <SignUpImage>
            <div>
               <Star />
               <h1>Why Metricks?</h1>
               <p>Take advantage of our unique features</p>

               <ul>
                  <li>
                     <Image src={Check} alt="check" />
                     <span>Integrate Metricks with over 20+ APIs</span>
                  </li>
                  <li>
                     <Image src={Check} alt="check" />
                     <span>Experience no limits - create as many campaigns as you need.</span>
                  </li>

                  <li>
                     <Image src={Check} alt="check" />
                     <span>Give your affiliates access to all your campaigns with one sign up</span>
                  </li>

                  <li>
                     <Image src={Check} alt="check" />
                     <span>
                        Communicate with your affiliates in real-time with in-app messaging s
                     </span>
                  </li>
               </ul>
            </div>
         </SignUpImage>
         <div className="hidden"></div>
         <FormDiv>{children}</FormDiv>
      </LayoutWrapper>
   );
};
